import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'ce-progress-bar',
    templateUrl: './progress-bar.component.html',
    styleUrls: ['./progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProgressBarComponent implements OnInit {
    @Input() progress = 0;
    @Input() fileName: string;
    @Output() remove = new EventEmitter<void>();

    ngOnInit(): void {
        if (this.progress == null) {
            this.progress = 0;
        }
    }
}
